/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Box, CircularProgress as MuiCircularProgress, StylesProvider, withStyles } from '@material-ui/core';
import useSWR from 'swr';
import { dataFetcher, endpoints } from 'Api';
import { AppContext, AuthContext } from 'Context';
import ImageGroup from 'Components/ImageGroup/ImageGroup';
import PermissionDeniedModal from 'Components/PermissionDeniedModal';
import './innerPage.css';
import ProgressBar from 'Components/header/components/ProgressBar';
import backArrowIcon from '../../../Assets/backArrowIcon.svg';
import AlterImage from '../../../Assets/alter-image.png';
import SortControls from './SortControls';
import styles from './index.module.css';

const CircularProgress = withStyles({
  circle: {
    color: '#fff !important'
  }
})(MuiCircularProgress);

export const InnerPage = (isGrid) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAppSnackbar, setVisible, defaultCategoryName } = useContext(AppContext);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategoryID, setSelectedCategoryID] = useState(undefined);
  const [profileID, setProfileID] = useState(undefined);
  const [title, setTitle] = useState(undefined);
  const [thumbnail, setThumbnail] = useState(undefined);
  const [arrows, setArrows] = useState(false);
  const [loader, setLoader] = useState(true);
  const [start, setStart] = useState(0);
  const [limit] = useState(15);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isSorting, setIsSorting] = useState(false);
  const [sortBy, setSortBy] = useState('date');
  const [sortOrder, setSortOrder] = useState('DESC');
  const [showPermissionModal, setShowPermissionModal] = useState(false);
const { mutate: getCategoryDetails } = useSWR(
  [endpoints.getCategoryDetail, profileID, selectedCategoryID, start, limit, sortBy, sortOrder],
  {
    fetcher: (url, user_id, category_id, startVal, limitVal, sort_by, sort_order) => dataFetcher(url, { user_id, category_id, start: startVal, limit: limitVal, sort_by: sortBy, sort_order: sortOrder }),
    onSuccess: ({ success, videos, message, video_count }) => {
      if (success) {
        setIsSorting(false);
        if (videos.length === 0) {
          setHasMore(false);
        } else {
          let totalVideos;
          if (start === 0) {
            setSubCategories([{ title: '', videos }]);
            totalVideos = videos.length;
          } else {
            setSubCategories((prev) => {
              const newVideos = [...(prev[0]?.videos || []), ...videos];
              totalVideos = newVideos.length;
              return [{ title: '', videos: newVideos }];
            });
          }
          console.log('totalVideos', totalVideos, video_count);
          setHasMore(totalVideos < video_count);
        }
      } else {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: message || 'Oops! Something went wrong',
        });
      }
      setLoader(false);
      setIsLoadingMore(false);
    },
    onError: (error) => {
      const responseData = error?.response?.data;
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: responseData?.message || 'Oops! Something went wrong',
      });
      setLoader(false);
      setIsLoadingMore(false);
    },
  }
);

  useEffect(() => {
    if (!location?.state) return; // <--- prevent crash if state is null
    if (!selectedCategoryID) {
      setSelectedCategoryID(location.state.category_id ?? location.state.id);
      setProfileID(location.state.profile_id);
      setTitle(location.state.category_name ?? location.state.title);
      setThumbnail(location.state.icon);
      // setStart(0);
      setHasMore(true);
    }
    getCategoryDetails(endpoints.getCategoryDetail, location.state.profile_id, location.state.category_id ?? location.state.id);
  }, [selectedCategoryID, profileID, start, sortBy, sortOrder]);

useEffect(() => {
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const { scrollHeight, clientHeight } = document.documentElement;

    const scrollableHeight = scrollHeight - clientHeight;
    const scrollPercentage = (scrollTop / scrollableHeight) * 100;

    if (scrollPercentage >= 40 && !isLoadingMore && hasMore) {
      setIsLoadingMore(true);
      setStart((prev) => prev + limit); // ✅ SWR will auto re-fetch with new start
    }
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, [hasMore, isLoadingMore, limit]);

  const handleSort = (newSortBy, newSortOrder) => {
    // Skip if already selected (no change) - matches mobile behavior
    if (sortBy === newSortBy && sortOrder === newSortOrder) {
      return;
    }

    setIsSorting(true);
    setSortBy(newSortBy);
    setSortOrder(newSortOrder);
    setSubCategories([]);
    setStart(0);
    setHasMore(true);
  };

  return (
<div>
  {loader === true
  ? <ProgressBar />
: (
  <div>
<div onClick={() => { navigate(sessionStorage.getItem('navigateProfile')); localStorage.removeItem('prevlocation'); setVisible(true); }} aria-hidden="true">
    <img
      style={{ marginTop: 40, marginLeft: 30, height: 40, cursor: 'pointer' }}
      // className={styles.videoBackButton}
      src={backArrowIcon || AlterImage}
      onError={(e) => {
        e.target.src = AlterImage;
      }}
    />
</div>
  <div className={styles.rectangle}>
    <Box
      className={styles.image}
      style={{
        backgroundImage: `url(${thumbnail})`
      }}
    />
    <div className={styles.titleText}>
      <h3>
        {title}
      </h3>
    </div>
  </div>

    <div className="carousal">
  {/* Sort Controls - Keep visible during sorting */}
  {(isSorting || (!!subCategories?.length && subCategories[0]?.videos?.length > 0)) && (
    <SortControls onSort={handleSort} isLoading={isSorting} sortBy={sortBy} setSortBy={setSortBy} sortOrder={sortOrder} setSortOrder={setSortOrder} />
              )}
                    {/* Sorting happens in background - no loader overlay */}
    {!!subCategories?.length && (
      subCategories?.map((subCategory, idx) => (
        !!subCategory?.videos?.length && (
          <ImageGroup
            center="centerMe"
            isGrid
            videos={subCategory?.videos}
            key={idx}
            title={subCategory?.title}
            catG
            isPreview
            onShowPermissionModal={() => setShowPermissionModal(true)}
          />
        )
      ))
    )}
    {isLoadingMore && (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
        <CircularProgress size={30} />
      </div>
    )}
    </div>
  </div>
)}
<PermissionDeniedModal
  open={showPermissionModal}
  onClose={() => setShowPermissionModal(false)}
/>
</div>
  );
};
